import React from 'react'

import { Container, ButtonBackground, Button } from './styles'

function LinkButton(props){
  return (
    <Container>
      <ButtonBackground/>
      <Button selected={ props.selected } to={ props.link }>{ props.text }</Button>
    </Container>
  )
}

export default LinkButton